export default __webpack_public_path__ + "static/media/la-vista.3e3d9550.jpg";